export default "__VITE_ASSET__fb05acae__"